import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "mt-4" }

import CompanySoMesField from "@/components/CompanySoMesField.vue";
import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import CountrySelect from "@/components/CountrySelect.vue";
import MunicipalitySelect from "@/components/MunicipalitySelect.vue";
import AddressBlock from "@/components/AddressBlock.vue";
import { useValidateProps } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { DraftCompanyDto } from "@api/draft-company-dto";
import { PropType, computed } from "vue";
import { CompanyFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import { isMobileReactive } from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyFormContactFields',
  props: {
	fieldsMap: {
		type: Object as PropType<CompanyFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftCompanyDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const fields = dbEnums.CompanyFields;

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoTeleInput = _resolveComponent("HakoTeleInput")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("companyForm.sectionContact.header")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.CompanyContactInfo?.fields)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.CompanyContactInfo.fields
            }, {
              [_unref(fields).PostalAddress]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  noLabel: ""
                }, {
                  default: _withCtx(({ fieldLabel }) => [
                    _createVNode(AddressBlock, {
                      idPrefix: field.id,
                      modelValue: formDataComputed.value.postalAddress,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.postalAddress) = $event)),
                      parentPath: "draftCompanyData.postalAddress",
                      label: fieldLabel,
                      style: {"max-width":"500px"}
                    }, null, 8, ["idPrefix", "modelValue", "label"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).VisitingAddress]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  noLabel: ""
                }, {
                  default: _withCtx(({ fieldLabel }) => [
                    _createVNode(AddressBlock, {
                      idPrefix: field.id,
                      modelValue: formDataComputed.value.visitingAddress,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.visitingAddress) = $event)),
                      parentPath: "draftCompanyData.visitingAddress",
                      label: fieldLabel,
                      style: {"max-width":"500px"}
                    }, null, 8, ["idPrefix", "modelValue", "label"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).BillingAddress]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.billingAddress"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.billingAddress,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.billingAddress) = $event)),
                      id: elementId
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Website]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.website"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.website,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.website) = $event)),
                      id: elementId,
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).OnlineStore]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.onlineStore"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(_component_HakoInput, {
                      type: "url",
                      modelValue: formDataComputed.value.onlineStore,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.onlineStore) = $event)),
                      id: elementId,
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Email]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.email"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoInput, {
                      modelValue: formDataComputed.value.email,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.email) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Phone]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.phone"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTeleInput, {
                      modelValue: formDataComputed.value.phone,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.phone) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"250px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Some]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  noLabel: "",
                  field: field,
                  propertyPath: "draftCompanyData.companySoMes"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(CompanySoMesField, {
                      field: field,
                      modelValue: formDataComputed.value.companySoMes,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.companySoMes) = $event)),
                      id: elementId
                    }, null, 8, ["field", "modelValue", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).Homeland]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.homelandId"
                }, {
                  default: _withCtx(({ elementId }) => [
                    _createVNode(CountrySelect, {
                      valueSingle: formDataComputed.value.homeland,
                      "onUpdate:valueSingle": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.homeland) = $event)),
                      valueSingleId: formDataComputed.value.homelandId,
                      "onUpdate:valueSingleId": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.homelandId) = $event)),
                      ajax: true,
                      id: elementId,
                      lowercase: "",
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueSingle", "valueSingleId", "id"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).HomeMunicipality]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.homeMunicipalityId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(MunicipalitySelect, {
                      valueSingle: formDataComputed.value.homeMunicipality,
                      "onUpdate:valueSingle": _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.homeMunicipality) = $event)),
                      valueSingleId: formDataComputed.value.homeMunicipalityId,
                      "onUpdate:valueSingleId": _cache[11] || (_cache[11] = ($event: any) => ((formDataComputed.value.homeMunicipalityId) = $event)),
                      ajax: "",
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).IsElectronicCommunicationAllowed]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftCompanyData.isElectronicCommunicationAllowed"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoCheckbox, {
                        modelValue: formDataComputed.value.isElectronicCommunicationAllowed,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formDataComputed.value.isElectronicCommunicationAllowed) = $event)),
                        for: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "for", "isInvalid", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).Municipality]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.municipalityId"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(MunicipalitySelect, {
                      valueSingle: formDataComputed.value.municipality,
                      "onUpdate:valueSingle": _cache[13] || (_cache[13] = ($event: any) => ((formDataComputed.value.municipality) = $event)),
                      valueSingleId: formDataComputed.value.municipalityId,
                      "onUpdate:valueSingleId": _cache[14] || (_cache[14] = ($event: any) => ((formDataComputed.value.municipalityId) = $event)),
                      ajax: "",
                      style: {"max-width":"250px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).District]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftCompanyData.companyDistrict"
                }, {
                  default: _withCtx(({}) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.companyDistrict,
                      "onUpdate:valueSingle": _cache[15] || (_cache[15] = ($event: any) => ((formDataComputed.value.companyDistrict) = $event)),
                      valueSingleId: formDataComputed.value.companyDistrictId,
                      "onUpdate:valueSingleId": _cache[16] || (_cache[16] = ($event: any) => ((formDataComputed.value.companyDistrictId) = $event)),
                      infoTable: "CompanyDistricts",
                      translationsTable: "CompanyDistrictTranslations",
                      translationProperty: "name",
                      ajax: false,
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueSingle", "valueSingleId"])
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})